@if (effectiveData; as data) {
  @if(data.title) {
    <h2 mat-dialog-title [ngClass]="titleClass">
      {{ data.title }}
    </h2>
  }
  <div
    class="mat-dialog-content flex flex-col justify-center items-center text-center min-h-[150px] mb-6"
    >
    <i class="material-icons text-5xl" [ngClass]="iconClass">
      {{ data.icon }}
    </i>
    <p class="text-lg font-medium text-gray-700 mt-8">{{ data.message }}</p>
  </div>
  <div class="flex justify-between items-center w-full gap-2 mt-4 font-normal">
    <button
      class="h-[45px] px-14 flex justify-center items-center rounded-lg border-2 border-[#BDBDBD] text-gray-700  hover:bg-gray-100 w-[47%]"
      (click)="onNoClick()"
      >
      Cancelar
    </button>
    <button
      class="h-[45px] px-14 flex justify-center items-center rounded-lg font-[inherit] focus:outline-none w-[47%]"
      [ngClass]="buttonClass"
      [mat-dialog-close]="true"
      cdkFocusInitial
      >
      Confirmar
    </button>
  </div>
}
